(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dinamic-collection-listing-carousel"] && !window.DesignMode) return;
  try {
    
  ;(function($) {
    var $status = document.querySelector('.pagingInfo');
    var $slickElement = $('.js-slideshow-collections');

    $slickElement.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
      //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
      if(!slick.$dots){
        return;
      }
      var i = (currentSlide ? currentSlide : 0) + 1;
      $status.innerHTML = i + '<span></span>' + (slick.$dots[0].children.length);
    });
    $slickElement.slick({
      infinite: false,
      slidesToShow: 1,
      dots: true,
      fade:false,
      prevArrow: '<button class="btn-collections btn-prev"><svg width="32" height="12" viewBox="0 0 32 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.62402 10.7471L2.00002 6.12307L6.62402 1.50007" stroke="black" stroke-width="1.2" stroke-linecap="round"/><path d="M2.00049 6.12353L30.0005 6.12354" stroke="black" stroke-width="1.2" stroke-linecap="round"/></svg></button>',
      nextArrow: '<button class="btn-collections btn-next"><svg width="30" height="12" viewBox="0 0 30 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M24.3765 1.5L29.0005 6.124L24.3765 10.747" stroke="black" stroke-width="1.2" stroke-linecap="round"/><path d="M29 6.12354H1" stroke="black" stroke-width="1.2" stroke-linecap="round"/></svg></button>'
    });
  }(jQuery));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["FAQ-Section"] && !window.DesignMode) return;
  try {
    
  var coll = document.getElementsByClassName("collapsible");
  var i;

  for (i = 0; i < coll.length; i++) {
    coll[i].addEventListener("click", function(event) {
      event.stopPropagation();  // Add this line

      this.classList.toggle("active");
      var content = this.nextElementSibling;
      if (content.style.maxHeight){
        content.style.maxHeight = null;
      } else {
        content.style.maxHeight = content.scrollHeight + "px";
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-popup"]) return;
  try {
    
;(function() {
  const popup = jQuery('.js-newsletter_popup');
  const openedClass = 'opened';
  const bodyOpenedClass = 'newsletter-popup-opened';
  const control = jQuery('.js-newsletter-popup__form');
  const closeBtn = popup.find('.js-newsletter_close');
  const body = jQuery('body');

  closeBtn.on('click touchend', function(e) {
  e.preventDefault();
  if (jQuery(this).hasClass('newsletter-popup__close')) {
  jQuery.cookie('newsletter_popup_disabled', '1');
  }
  hidePopup();
  });

  if (jQuery.cookie('newsletter_popup_disabled') !== '1') {
  setTimeout(function() {
  if (popup.length) {
  showPopup();

  controlCookie();

  jQuery(document).on('click',function (e) {
  if(popup.hasClass(openedClass)) {
  if (!jQuery(e.target).closest(popup).length) {
  hidePopup();
  }
  }
  });
  }
  }, popup.data('delay'));
  }

  function showPopup() {
  popup.addClass(openedClass);
  body.addClass(bodyOpenedClass);
  }

  function hidePopup() {
  popup.removeClass(openedClass);
  body.removeClass(bodyOpenedClass);
  }

  function controlCookie() {
  control.on('submit', function() {
  jQuery.cookie('newsletter_popup_disabled', '1');
  });
  }


  jQuery('.js-validation').formValidation({
  errorClass: 'newsletter-popup__error',
  addClassToParent: '.newsletter-popup__row'
  });
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quality-description"] && !window.DesignMode) return;
  try {
    

// List of image URLs
const imageUrls = [
  "https://cdn.shopify.com/s/files/1/0566/6317/9463/files/Tones_and_Huse.webp?v=1697469604",
  "https://cdn.shopify.com/s/files/1/0566/6317/9463/files/Velvet_Silk.webp?v=1697469603",
  "https://cdn.shopify.com/s/files/1/0566/6317/9463/files/Patterns.webp?v=1697469604",
  "https://cdn.shopify.com/s/files/1/0566/6317/9463/files/Snuggle.webp?v=1697469604",
  "https://cdn.shopify.com/s/files/1/0566/6317/9463/files/Bold_colors_1.webp?v=1697469603",
  "https://cdn.shopify.com/s/files/1/0566/6317/9463/files/Fluffed_Pillows.webp?v=1697578072",
  "https://cdn.shopify.com/s/files/1/0566/6317/9463/files/Patterns_over_Hues.webp?v=1697578073",
  "https://cdn.shopify.com/s/files/1/0566/6317/9463/files/LAYERING_MODERN.webp?v=1697578072",
  "https://cdn.shopify.com/s/files/1/0566/6317/9463/files/Bright_Patterns.webp?v=1697578072",
  "https://cdn.shopify.com/s/files/1/0566/6317/9463/files/Bigger_Bolder.webp?v=1697578072",
  "https://cdn.shopify.com/s/files/1/0566/6317/9463/files/Floofisms.webp?v=1697578073",
  "https://cdn.shopify.com/s/files/1/0566/6317/9463/files/Unleash_Your_Designer.webp?v=1697578073"
];

// Get the image element
const imgElement = document.querySelector(".FloofismSectionImg");

// Function to change the image source on page reload
function changeImageOnReload() {
  // Get the current image index from localStorage (or set it to 0 if not available)
  let currentIndex = parseInt(localStorage.getItem("imageIndex")) || 0;

  // Append a cache-busting parameter to the image URL
  const imageUrlWithCacheBust = `${imageUrls[currentIndex]}?cache=${Date.now()}`;

  // Set the image source
  imgElement.src = imageUrlWithCacheBust;

  // Increment the index for the next reload and reloop if it reaches the end
  currentIndex = (currentIndex + 1) % imageUrls.length;

  // Store the updated index in localStorage
  localStorage.setItem("imageIndex", currentIndex);
}

// Call the function to change the image on page reload
changeImageOnReload();

const carouselContainer = document.querySelector('.carousel-container');
const carouselWrapper = document.querySelector('.carousel-wrapper');
const slides = document.querySelectorAll('.carousel-slide');
const paginationContainer = document.querySelector('.pagination');

let currentIndex = 0;
let startX;
let endX;

// Create pagination buttons
for (let i = 0; i < slides.length; i++) {
  const button = document.createElement('button');
  button.classList.add('pagination-button');
  if (i === 0) button.classList.add('active');
  button.dataset.index = i;
  paginationContainer.appendChild(button);
  button.addEventListener('click', () => {
    updateCarousel(parseInt(button.dataset.index));
  });
}

// Update carousel position and pagination buttons
function updateCarousel(index) {
  currentIndex = index;
  const translateX = -currentIndex * 100;
  carouselWrapper.style.transform = `translateX(${translateX}%)`;
  paginationContainer.querySelectorAll('.pagination-button').forEach((button, i) => {
    button.classList.toggle('active', i === currentIndex);
  });
}

// Event listeners for swiping
carouselContainer.addEventListener('touchstart', (e) => {
  startX = e.touches[0].clientX;
});

carouselContainer.addEventListener('touchend', (e) => {
  endX = e.changedTouches[0].clientX;
  if (startX - endX > 50) {
    updateCarousel((currentIndex + 1) % slides.length);
  } else if (startX - endX < -50) {
    updateCarousel((currentIndex - 1 + slides.length) % slides.length);
  }
});

carouselContainer.addEventListener('mousedown', (e) => {
  startX = e.clientX;
  carouselContainer.style.cursor = 'grabbing';
});

carouselContainer.addEventListener('mouseup', (e) => {
  endX = e.clientX;
  if (startX - endX > 50) {
    updateCarousel((currentIndex + 1) % slides.length);
  } else if (startX - endX < -50) {
    updateCarousel((currentIndex - 1 + slides.length) % slides.length);
  }
  carouselContainer.style.cursor = 'grab';
});

// Prevent text selection while swiping
carouselContainer.addEventListener('selectstart', (e) => {
  e.preventDefault();
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["static-trade-projects"]) return;
  try {
    
;(function($) {
  const $slickElement = $('.js-trade-projects-carousel');

  $slickElement.slick({
    slidesToScroll: 1,
    rows: 0,
    dots: true,
    prevArrow: '<button class="btn-trade-projects btn-prev"><svg width="32" height="12" viewBox="0 0 32 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.62402 10.7471L2.00002 6.12307L6.62402 1.50007" stroke="black" stroke-width="1.2" stroke-linecap="round"/><path d="M2.00049 6.12353L30.0005 6.12354" stroke="black" stroke-width="1.2" stroke-linecap="round"/></svg></button>',
    nextArrow: '<button class="btn-trade-projects btn-next"><svg width="30" height="12" viewBox="0 0 30 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M24.3765 1.5L29.0005 6.124L24.3765 10.747" stroke="black" stroke-width="1.2" stroke-linecap="round"/><path d="M29 6.12354H1" stroke="black" stroke-width="1.2" stroke-linecap="round"/></svg></button>',
    variableWidth: true,
    centerMode: true,
    centerPadding: '340px',
    responsive: [
      {
        breakpoint: 750,
        settings: {
          variableWidth: true,
          centerMode: true,
          centerPadding: '12px',
        }
      }
    ]
  });
}(jQuery));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials-slider"] && !window.DesignMode) return;
  try {
    
document.getElementById("all-reviews-button").onclick = function () {
    location.href = "https://floofliving.com/pages/reviews";
};

fetch('https://cdn.shopify.com/s/files/1/0566/6317/9463/files/Testimonials.json?v=1693308141', {
    method: 'GET',
    headers: {
        'Accept': 'application/json',
    },
})
.then(response => response.json())
.then(data => {
    const swiperWrapper = document.getElementById("swiper-wrapper-content");
    swiperWrapper.innerHTML = ''; // Clear any existing testimonials

    const shapes = ["square"];
    let shapeIndex = 0;

    data.slice(0, 6).forEach((review) => {
        const slideDiv = document.createElement("div");
        slideDiv.classList.add("slide");
        slideDiv.classList.add("swiper-slide");

        const shapeClass = shapes[shapeIndex];
        shapeIndex = (shapeIndex + 1) % shapes.length; // Cycle through the shapes

        slideDiv.innerHTML = `
            <img src="${review["Published Image URLs"].split("; ")[0]}" alt="" class="image ${shapeClass}-image-svg-mask" loading="lazy" />
            <div class="details">
                <span class="name">${review["Reviewer Display Name"]}</span>
                <div class="stars">
                    <span class="star">★</span><span class="star">★</span><span class="star">★</span><span class="star">★</span><span class="star">★</span>
                </div>
            </div>
            <p>${review["Review Content"]}</p>
            <a class="review__product_link" href="${review["Product URL"]}" style="color: #eb462d; text-decoration: none; padding-top: 20px; border-bottom: 1px solid #eb462d">Shop ${review["Product Title"]}</a>
        `;

        swiperWrapper.appendChild(slideDiv);
    });

    // Initialize the Swiper after appending the slides
    initializeSwiper();

}).catch(err => {
    console.error('Failed to fetch testimonials:', err);
});

function initializeSwiper() {
    var swiper = new Swiper(".mySwiper", {
        slidesPerView: 1,
        slidesPerGroup: 1,
        grabCursor: true,
        loop: true,
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        breakpoints: {
            768: {
                slidesPerView: 3,
                slidesPerGroup: 3
            },
        }
    });
}

  } catch(e) { console.error(e); }
})();
})();
